import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { MediaActions } from '../../_redux';
import { ThumbnailView } from '../_common';
import { MediaGalleryConstants } from '../../constants';
import ThumbnailItem from './ThumbnailItem';

const { MEDIA_FROM } = MediaGalleryConstants;

const mapStateToProps = state => {
  const medias = state.media.get(`${MEDIA_FROM.web}`);
  return {
    medias: medias.toList().toJS(),
    progress: state.media.get('progress'),
    selection: state.media.get('selection'),
  };
};

const mapDispatchToProps = {
  SEARCH_WEB_MEDIAS: MediaActions.SEARCH_WEB_MEDIAS,
  SET_MEDIA_SELECTION: MediaActions.SET_MEDIA_SELECTION,
};

class WebMedias extends React.Component {
  static propTypes = {
    selection: PropTypes.object,
    progress: PropTypes.object,
    medias: PropTypes.array,
    checkIsSelectionAllowed: PropTypes.func,
    onCrop: PropTypes.func.isRequired,
    onScroll: PropTypes.func.isRequired,
    SET_MEDIA_SELECTION: PropTypes.func.isRequired,
  }


  selectMedia = media => {
    this.props.SET_MEDIA_SELECTION({ ...this.props.selection, media, on: MEDIA_FROM.web });
  }

  cropImage = (image, e) => {
    e.stopPropagation();
    if (this.props.onCrop) {
      this.props.onCrop(image);
    }
  }

  render() {
    const {
      medias, progress, selection: { media } = {}, checkIsSelectionAllowed,
    } = this.props;

    return (
      <div className="gallery-container" onScroll={this.props.onScroll}>
        <ThumbnailView
          data={medias}
          selections={media}
          itemRenderer={ThumbnailItem}
          checkIsSelectionAllowed={checkIsSelectionAllowed}
          itemProps={{
            // onCrop: this.cropImage,
            uploadProgress: progress,
          }}
          onChange={this.selectMedia}
        />
      </div>
    );
  }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(WebMedias));
